import {
  ClientDataChangedDto,
  DefaultApi,
  GetExtendedSalesInvoiceDto,
} from '../autogenerated/pokApiClient';

export interface SalesInvoicesGetByIdContextInterface {
  getById: (id: string) => Promise<GetExtendedSalesInvoiceDto>;
  getByIdForImport: (id: string) => Promise<GetExtendedSalesInvoiceDto>;
  checkClientDataChanged: (id: string) => Promise<ClientDataChangedDto>;
}

export const SalesInvoiceGetByIdContext = (
  api: DefaultApi,
): SalesInvoicesGetByIdContextInterface => {
  return {
    getById: (id: string) => api.salesInvoiceGetByIdControllerGet(id),
    getByIdForImport: (id: string) =>
      api.salesInvoiceGetByIdControllerGetByIdForImport(id),
    checkClientDataChanged: (id: string) =>
      api.salesInvoiceGetByIdControllerCheckClientDataChanged(id),
  };
};
